import { Box, Stack } from "@mui/system";
import React from "react";

const LoginLogos = () => {
  return (
    <Stack direction="row" justifyContent="center" alignItems="center"  >
      <Box
        sx={{
          width: {
            xs: "150px",
            md: "150px",
            marginBottom:"40px"
          },
        }}
      >
        <img src="/assets/images/gaif-logo.png" alt="logo" loading="lazy" width="100%" />
      </Box>
    </Stack>
  );
};

export default LoginLogos;
